import { render, staticRenderFns } from "./WhiteLayout.vue?vue&type=template&id=24259e36"
import script from "./WhiteLayout.vue?vue&type=script&lang=js"
export * from "./WhiteLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports